module.exports = __webpack_public_path__ + "img/foot4.5c74003b.png";